
import React, { Component } from 'react'
import { connect } from 'react-redux'

import SearchGrid from '../shared/SearchGrid'

class AdminRecordPatterns extends Component {
  magicRef = React.createRef()

  render () {
    const columns = [
      {
        display: r => r.name,
        title: 'Name',
        sort: 'name'
      },
      {
        display: r => r.medical_plan_name,
        title: 'Medical Plan Name',
        sort: 'medical_plan_name'
      },
      {
        display: r => r.lastname,
        title: 'Last Name',
        sort: 'lastname'
      },
      {
        display: r => r.firstname,
        title: 'First Name',
        sort: 'firstname'
      },
      {
        display: r => r.ssn,
        title: 'SSN',
        sort: 'ssn'
      }
    ]
    return (
      <div className='admin-records root'>
        <div className='admin-records records'>
          <h1
            style={{
              display: 'flex',
              justifyContent: 'space-between',
              alignItems: 'baseline'
            }}
          >
            <b>Admin Record Patterns</b>
          </h1>
          <SearchGrid
            label='Search by Name, Medical Plan Name, Last Name, First Name and SSN'
            columns={columns}
            url='/admin/warehouse/admin/patterns'
          />
        </div>
      </div>
    )
  }
}
export default connect(redux => ({
    patterns: redux?.admin?.admin_record_patterns ?? {}
}))(AdminRecordPatterns)
